import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { Button } from '@/components/button'
import { getDatasetName } from '@/utils/outputReports'

const addCommandCell = ({ localize, datasets, onReportSubmissionGroupAdd }) => {
  return class AddCommandCell extends GridCell {
    onAdd = (index) => () => {
      onReportSubmissionGroupAdd(index, this.props.dataItem)
    }
    render () {
      const buttons = []
      for (let i = 0; i < datasets.length; i++) {
        const dataset = datasets[i]
        const text = `${localize('Reporting.Dataset')} ${getDatasetName(dataset.index, localize)}`
        buttons.push(<div key={`add-button-${dataset.index}`}><Button icon='plus' color='primary' onClick={this.onAdd(dataset.index)}>{text}</Button></div>)
      }
      return (
        <td>{buttons}</td>
      )
    }
  }
}

const addBulkButtons = ({ localize, datasets, onReportSubmissionGroupsBulkAdd, getFilteredData }) => {
  const onClick = (index) => async () => {
    const filteredData = await getFilteredData()
    onReportSubmissionGroupsBulkAdd(index, filteredData.data)
  }

  const buttons = datasets.map(x =>
    <Button key={x.index} icon='plus' color='primary' onClick={onClick(x.index)}>
      {`${localize('Reporting.Dataset')} ${getDatasetName(x.index, localize)}`}
    </Button>)
  return <React.Fragment>{buttons}</React.Fragment>
}

const removeCommandCell = ({ localize, datasetIndex, onReportSubmissionGroupRemove }) => {
  return class RemoveCommandCell extends GridCell {
    onRemove = () => {
      onReportSubmissionGroupRemove(datasetIndex, this.props.dataItem)
    }
    render () {
      return (
        <td>
          <Button icon='x' color='primary' title={localize('Common.Remove')} onClick={this.onRemove} />
        </td>
      )
    }
  }
}

export {
  addCommandCell,
  addBulkButtons,
  removeCommandCell
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/grids/commandCells.js